import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import Test_img1 from "../images/img1.jpeg";
import Test_img4 from "../images/img2.jpeg";
import Test_img5 from "../images/img3.jpeg";
import Test_img7 from "../images/img4.jpg";
import Test_img9 from "../images/img5.jpg";
import Test_img10 from "../images/img6.jpg";
import Test_img8 from "../images/img7.jpeg";
import "./explore_js.css";
import "./slick.css";
import { Link } from "react-router-dom";
export default class DemoCarousel extends Component {
  render() {
    return (
      <>
        <div className="explore_container">
          <h2>The White Dental</h2>
          <Carousel
            showThumbs={false}
            showArrows={true}
            infiniteLoop={true}
            showIndicators={true}
            showStatus={false}
            interval={2500}
            autoPlay
            stopOnHover={false}
            centerMode={true}
          >
            <div>
              <img src={Test_img1} alt="img_here" />
            </div>
            <div>
              <img src={Test_img4} alt="img_here" />
            </div>
            <div>
              <img src={Test_img5} alt="img_here" />
            </div>
            <div>
              <img src={Test_img7} alt="img_here" />
            </div>
            <div>
              <img src={Test_img9} alt="img_here" />
            </div>
            <div>
              <img src={Test_img10} alt="img_here" />
            </div>
            <div>
              <img src={Test_img8} alt="img_here" />
            </div>
          </Carousel>
          <div className="info">
            <p>
              The White Dental Clinic is Established in East of kailash.It was
              Established in Year The White Dental Clinic is own by Dr Sandeep
              Jangra. Dr Sandeep Kumar Jangra is an astute clinician with a
              strong academic background having 15 years of rich experience in
              the field of dentistry. <br />
              <br />
              He holds a bachelors degree (BDS) from the well known Government
              Dental College, PGIMS ,Rohtak and masters (MDS) in Orthodontics
              and Dentofacial Orthopedics from the most prestigious medical
              institute of the country AIIMS, New Delhi. He was felicitated by
              the Government of Haryana for his outstanding performance in AIIMS
              post-graduate entrance in the year 2006.
              <br />
              <br />
              Following his MDS he has done his senior residency from AIIMS,New
              Delhi as well as worked as a faculty with ESIC Dental College and
              Hospital, Rohini, Delhi. He has treated people from all walks of
              life with care and personal affection, maintaining an honest and
              ethical approach in his practice. He is dedicated to the highest
              level of excellence in the art and science of cosmetic dentistry
              He has been expertly trained in comprehensive orthodontics
              including conventional labial, lingual and invisible braces, but
              his area of special interest continues to be treating malocclusion
              as nonextraction with simpler mechanics.. Besides being a diligent
              clinician par excellence he continues to actively participate in
              various national and international conferences to keep himself
              abreast with the latest techniques and technology available
              worldwide in the field of orthodontics and dentistry.
              <br />
              <br /> He has several national and international publications to
              his credit including a study on the MRI of temporomandibular joint
              following the treatment of severely proclined teeth as non
              extraction method with functional appliances. He is a certified
              implantologist and has done several implants successfully over the
              past 9 years.
            </p>
          </div>
          <div className="ex_btn">
            <Link to="/">
              <p>
                <i class="fas fa-backward"></i>Back to Home
              </p>
            </Link>
          </div>
        </div>
      </>
    );
  }
}
